import React from "react";
import { IIconButton, IconButtonType, IconButtonTypeClass, IconButtonTypeComponent } from "../../interfaces/Components/IconButton/IIconButton";
import { Button } from 'react-bootstrap';
import { Spinner } from "../Spinner/Spinner";

import './IconButton.scss';

export const IconButton: React.FC<IIconButton> = ({ iconType, spin, children, ...props }) => {

    const buttonClassName = `icon-button ${IconButtonTypeClass[iconType]} ${props.className || ''}`;

    const renderPreStatus = () => {
        if (spin && iconType !== IconButtonType.Next) return <Spinner animation="grow" visible={true} spinnerText="Sending" />;
        if (iconType === IconButtonType.Next) {
            return null;
        } else {
            return IconButtonTypeComponent[iconType];
        }
    };

    const renderPostStatus = () => {
        if (iconType !== IconButtonType.Next) return null;
        return spin ? 
            <Spinner animation="grow" visible={true} spinnerText="Sending" /> :
            IconButtonTypeComponent[IconButtonType.Next]
    };


    return (
        <Button {...props} className={buttonClassName}>
            <div className="wrapper">
                {renderPreStatus()}
                <div className="children">
                    {children}
                </div>
                {renderPostStatus()}
            </div>
        </Button>
    );

}
